import React from 'react'
import styled from 'styled-components'

interface CheckProps {
  checked?: any
  type?: string
  children?: string
  onChange?: any
  value?: any
  name?: any
  disabled?: any
  onClick?: any
}

const Wrapper = styled.div`
  width: auto;

  & label {
    width: 90%;
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    & input ~ span {
      background-color: ${({ theme }) => theme.colors.whitesmoke};
      outline: 5px solid ${({ theme }) => theme.colors.white};
    }
    & input:checked ~ span {
      background-color: ${({ theme }) => theme.colors.primary};
      margin-top: -3px;
      border-radius: 6px;
      -moz-outline-radius: 6px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        border-radius: 50%;
      }
    }
    & input:checked ~ span:after {
      display: block;
    }
    & span:after {
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
      border: solid ${({ theme }) => theme.colors.white};
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    outline: 2px solid ${({ theme }) => theme.colors.red};
  }
  span {
    position: absolute;
    top: -2px;
    left: 0;
    height: 25px;
    width: 25px;
    border-radius: 5px;
    outline: 6px solid ${({ theme }) => theme.colors.red};

    background-color: ${({ theme }) => theme.colors.whitesmoke};
    &:after {
      content: '';
      position: absolute;
      display: none;
    }
  }
`

const CustomCheckBox = ({
  type,
  checked,
  onChange,
  children,
  value,
  disabled,
  onClick,
  ...rest
}: CheckProps) => {
  return (
    <Wrapper {...rest}>
      <label>
        {children}
        <input
          type="checkbox"
          name="check"
          onChange={onChange}
          checked={checked}
          value={value}
          disabled={disabled}
          onClick={onClick}
        />
        <span></span>
      </label>
    </Wrapper>
  )
}

const TargetCheckbox = styled(CustomCheckBox)`
  width: 34px;
  & label {
    width: 500px;
    & input:checked ~ span {
      background-color: ${({ theme }) => theme.colors.CollaboBlue};
    }
  }
`

const InvestCheckbox = styled(CustomCheckBox)`
  & label {
    /* width: 500px; */
    & input:checked ~ span {
      background-color: ${({ theme }) => theme.colors.blue};
    }
  }
`

export { CustomCheckBox, TargetCheckbox, InvestCheckbox }
